import { mapValues } from 'lodash';

const comicSelectors = {
  loading: state => state.comicReducer.loading,
  comics: state => {
    const comicsData = state.comicReducer.comics;
    return mapValues(comicsData, comic => ({ ...comic, rating: comic.rating.average }));
  },
};

export default comicSelectors;